import React from "react"
import { sortCaret } from "../../_metronic/_helpers";

export function generateCols(data, cols, totalizer_cols, money_cols = []) {
  return cols.map(col => {
    if (!totalizer_cols.includes(col.dataField)) {
      return { ...col, footer: "-" }
    }
    const total = data.reduce((acc, row) => acc + Number(row[col.dataField] ?? 0), 0)
    return {
      ...col,
      footer: total,
      footerFormatter: money_cols.includes(col.dataField) ?
        priceFormatter : unitsFormatter
    }

  })
}
export function optionsFactory(documents, customSize = 10) {
  ////console.log(documents)
  return {
    paginationSize: customSize,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: 'First',
    prePageText: 'Back',
    nextPageText: 'Next',
    lastPageText: 'Last',
    nextPageTitle: 'First page',
    prePageTitle: 'Pre page',
    firstPageTitle: 'Next page',
    lastPageTitle: 'Last page',
    showTotal: true,
    disablePageTitle: true,
    totalSize: documents.length ?? 0,
    sizePerPageList: [{
      text: String(customSize), value: customSize
    }, {
      text: '20', value: 20
    }, {
      text: 'All', value: documents.length ?? 0
    }] // A numeric array is also available. the purpose of above example is custom the text
  };
}
export function parseXLS(data, cols) {
  const formatted = [...data].map(row => {
    const dataFields = []
    for (const col of cols) {
      const _field = col.dataField
      dataFields.push(row[_field] ?? "")

    }
    return dataFields
  })
  const headers = cols.map(row => row.text)

  return [headers, formatted]
}
export function filterFactory(documents = [], filter = "", fields = []) {
  const result = documents.filter((data) => {
    for (const field of fields) {
      const _string = String(data[field] ?? "")
      const value = _string.toUpperCase();
      if (value.indexOf(filter.toUpperCase()) >= 0) {
        return true;
      }
    }
    return false;
  })
  return result
}
export function unitsPlainFormatter(column) {
  return (
    <h6><strong>{Number(Number(column.footer ?? 0))}</strong></h6>
  );
}
export function percentFormatter(column) {
  return (
    <h6><strong>{Number(Number(column.footer ?? 0).toFixed(2))}%</strong></h6>
  );
}
export function percentFormatterColor(column) {
  function getColor(n) {
    if (n <= 89) {
      return "text-danger"
    }
    if (n > 89 && n < 100) {
      return "text-warning"
    }
    if (n >= 100) {
      return "text-success"
    }
  }
  return (
    <h6><strong className={getColor(Number(column.footer ?? 0))}>{Number(Number(column.footer ?? 0).toFixed(2))}%</strong></h6>
  );
}
export function priceFormatter(column) {
  return (
    <h6><strong>{process.env.REACT_APP_CURRENCY}{Number(column.footer ?? 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</strong></h6>
  );
}
export function priceStringFormatter(value) {
  return String(process.env.REACT_APP_CURRENCY + "" + Number(value ?? 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","))
}
export function priceStringFormatterAlt(value, div, multi) {
  const v = (value / div) * multi
  return String(process.env.REACT_APP_CURRENCY + "" + Number(v ?? 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","))
}
export function price(value) {
  return <>{process.env.REACT_APP_CURRENCY}{Number(value ?? 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</>
}

const addCommas = function (input) {
  return (input.toString()).replace(/^([-+]?)(0?)(\d+)(.?)(\d+)$/g, function (match, sign, zeros, before, decimal, after) {

      var reverseString = function (string) { return string.split('').reverse().join(''); };

      var insertCommas = function (string) {

        var reversed = reverseString(string);

        var reversedWithCommas = reversed.match(/.{1,3}/g).join(',');

        return reverseString(reversedWithCommas);
      };

      return sign + (decimal ? insertCommas(before) + decimal + after : insertCommas(before + after));
    }
  );
}; 
export function unitsFormatter(column) {
  return (
    <h6><strong>{addCommas(Number(column.footer ?? 0).toFixed(Number(process.env["REACT_APP_UNITS"])))}</strong></h6>
  );
}

export function FilterLayout({ controller }) {
  return (
    <>
      <div className="col-lg-2">
        <input
          type="text"
          className="form-control"
          name="searchText"
          placeholder="Search"
          onChange={({ target }) => {
            const { value } = target;
            controller(value);
          }}

        />
        <small className="form-text text-muted">
          <b>Search</b> in all fields
        </small>
      </div>
      <br />
    </>
  )
}



//! ignore everuthing above this
export function _priceDocumentFormatter(value) {
  return (
    process.env.REACT_APP_CURRENCY + Number(value ?? 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  );
}
export function _numberDocumentFormatter(value) {
  return Number(value ?? 0)
}
export function _stringDocumentFormatter(value) {
  return String(value ?? 0)
}
export function _unitsDocumentFormatter(value) {
  return (addCommas(Number(value ?? 0).toFixed(Number(process.env["REACT_APP_UNITS"]))));
}

export function _priceFormatter(value) {
  return (
    <h6><strong>{process.env.REACT_APP_CURRENCY}{Number(value ?? 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</strong></h6>
  );
}
export function _numberFormatter(value) {
  return Number(value ?? 0)
}
export function _stringFormatter(value) {
  return String(value ?? 0)
}
export function _unitsFormatter(value) {
  return (
    <h6><strong>{addCommas(Number(value ?? 0).toFixed(Number(process.env["REACT_APP_UNITS"])))}</strong></h6>
  );
}


export function _priceFooterFormatter(value) {
  return (
    <h6><strong>{process.env.REACT_APP_CURRENCY}{Number(value.footer ?? 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</strong></h6>
  );
}
export function _stringFooterFormatter(value) {
  return String(value.footer ?? 0)
}
export function _unitsFooterFormatter(value) {
  return (
    <h6><strong>{addCommas(Number(value.footer ?? 0).toFixed(Number(process.env["REACT_APP_UNITS"])))}</strong></h6>
  );
}
const _formatters = {
  number: _numberFormatter,
  string: _stringFormatter,
  units: _unitsFormatter,
  amount: _priceFormatter
}
const _documentFormatters = {
  number: _numberDocumentFormatter,
  string: _stringDocumentFormatter,
  units: _unitsDocumentFormatter,
  amount: _priceDocumentFormatter
}
const _footerFormatters = {
  string: _stringFooterFormatter,
  units: _unitsFooterFormatter,
  amount: _priceFooterFormatter
}
export function normalizeData(docs = [], cols = []) {


  const _table = {
    options: optionsFactory(docs),
    body: []
  }
  const _cols = []

  const _document = {
    columns: [],
    data: []
  }

  for (const doc of docs) {
    const row = []
    for (const col of cols) {
      if (col.export) {

        const value = doc[col.dataField] ?? ""
        const formatter = col.documentFormatter ?? _documentFormatters[col.type ?? "string"]
        const cell = {
          value: formatter(value),
          style: { font: { sz: "24", bold: true } }
        }

        row.push(cell)
      }
    }
    _document.data.push(row)

  }
  for (const col of cols) {
    let footer = "-"
    if (col.export) {
      if (!_document.columns.includes(col.text)) {
        const size = col.headerStyle ?? { width: '120px' }
        const header = {
          value: col.text,
          widthPx: Number(size.width.replace("px", "")),
          style: {
            fill: { patternType: "solid", fgColor: { rgb: "FFFF0000" } },
            font: { sz: "24", bold: true }
          },

        }

        _document.columns.push(header)
      }
    }

    if (col.totalize) {
      const total = docs.reduce((acc, row) => acc + Number(row[col.dataField] ?? 0), 0)
      footer = total
    }

    _cols.push({
      ...col,
      sort: true,
      sortCaret: sortCaret,
      formatter: col.formatter ?? _formatters[col.type ?? "string"],
      footer: footer,
      documentFormatter: col.documentFormatter ?? _documentFormatters[col.type ?? "string"],
      footerFormatter: _footerFormatters[col.type ?? "string"]
    })
  }

  return [_table, _document, _cols]
}
export function diff_minutes(dt2, dt1) {
  var diff = (dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60;
  return Math.round(diff)
}